/**
 * Maten-normalisatie (batch-3 B, bug 2 - "halve schoenmaten").
 *
 * Kleding-/schoen-/handschoen-/helmmaten worden als vrije tekst opgeslagen
 * (de API-kolommen zijn `String?`). Halve schoenmaten ("41,5"/"44,5") moeten
 * gewoon kunnen; het backoffice-veld stond eerder als `type="number" step="1"`
 * waardoor de browser een komma-/halve-maat afwees.
 *
 * Deze helper is de ENE bron voor het consistent opslaan van een maat:
 * - trimt witruimte;
 * - canonicaliseert een decimale (halve) maat naar de NL-komma-notatie zodat
 *   "41.5" en "41,5" identiek opgeslagen worden (de portal toont "44,5");
 * - laat vrije tekst (S/M/L, "W33", "44 breed", "9") ongemoeid - er wordt
 *   niets numeriek afgedwongen.
 *
 * Bewust geen validatie/afwijzing: de maat blijft string en mag van alles zijn.
 */
export function normaliseerMaat(value: string | null | undefined): string {
  const trimmed = (value ?? '').trim()
  // Alleen een kale decimale maat (1-2 cijfers, één decimaal, punt OF komma)
  // canonicaliseren naar komma. "44" blijft "44"; "44 breed"/"L" blijft ongemoeid.
  if (/^\d{1,2}[.,]\d$/.test(trimmed)) {
    return trimmed.replace('.', ',')
  }
  return trimmed
}

/**
 * Normaliseert een maat naar een opslag-waarde: lege/whitespace string -> null
 * (zodat een leeggemaakt veld als "onbekend" wegschrijft i.p.v. als lege string).
 */
export function normaliseerMaatOrNull(value: string | null | undefined): string | null {
  return normaliseerMaat(value) || null
}
